import moment, { Moment } from "moment";

export const RECENT_ORDER_LOOKBACK_MONTHS = 1;

export const getRecentOrderDateFilter = (now: Moment = moment()) => ({
  key: "IncomingOrder.DatePlaced",
  value: {
    startAt: now.clone().subtract(RECENT_ORDER_LOOKBACK_MONTHS, "month").startOf("day").toISOString(),
    endAt: now.clone().endOf("day").toISOString(),
  },
});
